import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export function emailResetPasswordAction(email: string): Promise<ApiResponse<null>> {
  return api.get<ApiResponse<null>>(`/auth/reset-password`, {
    params: { email },
  })
}
